import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { LogLevel } from './logLevel.enum';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  private currentLogLevel = environment.LogLevel;

  constructor(private http: HttpClient) {}

  setLogLevel(level: LogLevel): void {
    this.currentLogLevel = level;
  }

  private logMessage(
    level: LogLevel,
    message: string,
    ...optionalParams: unknown[]
  ): void {
    const timeOfError = new Date().toLocaleString();
    if (level >= this.currentLogLevel) {
      switch (level) {
        case LogLevel.DEBUG:
          console.debug(
            `%cDEBUG at ${timeOfError} `,
            'color: gray',
            message,
            ...optionalParams
          );
          break;
        case LogLevel.INFO:
          console.info(
            `%cINFO at ${timeOfError}`,
            'color: blue',
            message,
            ...optionalParams
          );
          break;
        case LogLevel.LOG:
          console.log(
            `%cLOG at ${timeOfError}`,
            'color: #10b3b0',
            message,
            ...optionalParams
          );
          break;
        case LogLevel.WARN:
          console.warn(
            `%cWARNING at ${timeOfError}`,
            'color: orange',
            message,
            ...optionalParams
          );
          break;
        case LogLevel.ERROR:
          console.error(
            `%cERROR at ${timeOfError}`,
            'color: red',
            message,
            ...optionalParams
          );
          break;
      }
    }
  }

  log(message: any, ...optionalParams: any[]): void {
    this.logMessage(LogLevel.LOG, message, ...optionalParams);
    this.sendLogToServer('log', message, optionalParams);
  }

  info(message: any, ...optionalParams: any[]): void {
    this.logMessage(LogLevel.INFO, message, ...optionalParams);
    this.sendLogToServer('info', message, optionalParams);
  }

  warn(message: any, ...optionalParams: any[]): void {
    this.logMessage(LogLevel.WARN, message, ...optionalParams);
    this.sendLogToServer('warn', message, optionalParams);
  }

  error(message: any, ...optionalParams: any[]): void {
    this.logMessage(LogLevel.ERROR, message, ...optionalParams);
    this.sendLogToServer('error', message, optionalParams);
  }

  debug(message: any, ...optionalParams: any[]): void {
    this.logMessage(LogLevel.DEBUG, message, ...optionalParams);
    this.sendLogToServer('debug', message, optionalParams);
  }

  private sendLogToServer(
    level: string,
    message: any,
    optionalParams: any[]
  ): void {}
}
